import { z } from 'zod';

const FacultyDivisionQuery = z.array(z.object({
    Neme: z.string(),
    Code: z.string(),
}));

export { FacultyDivisionQuery };